import { render, staticRenderFns } from "./KabupatenKota.vue?vue&type=template&id=5d3e47a2"
import script from "./KabupatenKota.vue?vue&type=script&lang=js"
export * from "./KabupatenKota.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports